export const privateProviderLicenseTypes = [
  { code: "PE", label: "Professional Engineer" },
  { code: "RA", label: "Registered Architect" },
  { code: "BCA", label: "Building Code Administrator" },
  { code: "BCI-Building", label: "Building Inspector" },
  { code: "BCI-Electrical", label: "Electrical Inspector" },
  { code: "BCI-Mechanical", label: "Mechanical Inspector" },
  { code: "BCI-Plumbing", label: "Plumbing Inspector" },
  { code: "BCPE-Building", label: "Plans Examiner - Building" },
  { code: "BCPE-Electrical", label: "Plans Examiner - Electrical" },
  { code: "BCPE-Mechanical", label: "Plans Examiner - Mechanica" },
  { code: "BCPE-Plumbing", label: "Plans Examiner - Plumbing" },
];

export const companyPrivateProvider = {
  id: "1111111111111",
  pp_company_name: "Permit Rockstar Private Provider LLC",
  pp_address: "9218 Cypress Green Dr - Jacksonville, FL 32256",
  pp_phone: "904-422-2128",
  pp_email: "ali@permitrockstar.com",
  pp_name: "Ali Marar",
  pp_license: "PE92978",
  created_at: 1763563213,
};
